import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CuocDieuTraGis {
  name: string;
  api_token: string;
}

export interface CuocDieuTraGisDetaiInfor {
  errors: unknown;
  CuocDieuTraGis: CuocDieuTraGis;
  isAuthenticated: boolean;
}

@Module
export default class CuocDieuTraGisDetail
  extends VuexModule
  implements CuocDieuTraGisDetaiInfor
{
  errors = {};
  CuocDieuTraGis = {} as CuocDieuTraGis;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get CuocDieuTraGisDetail() {
    return this.cuocDieuTraGisDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.CUOC_DIEU_TRA_GIS_DETAIL_DATA](CuocDieuTraGis) {
    this.cuocDieuTraGisDetailData = CuocDieuTraGis;
  }
  @Action
  [Actions.CUOC_DIEU_TRA_GIS_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/gis/dmcuocdieutra",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.CUOC_DIEU_TRA_GIS_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
